import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appAreaNotCovered]',
})
export class AreaNotCoveredDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
